import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Paper, Typography } from "@material-ui/core";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export class PortfolioFaultFrequencyChartByError extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartOptions: {
        chart: {
          type: 'pie',
          backgroundColor: null,
          animation: {
            duration: 800,
            easing: 'easeOutCubic'
          }
        },
        title: {
          text: ''
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return `
              <div style="
              width: 180px; 
              white-space: normal; 
              word-wrap: break-word;
              ">
                <strong>${this.point.name}</strong>: ${this.point.y}<br/>
                <strong>Affected Stations:</strong> ${this.point.affectedStations.join(', ')}
              </div>
            `;
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.displayName}</b>: {point.y}',
              style: {
                color: 'black'
              }
            },
            showInLegend: false
          }
        },
        series: [{
          name: 'Error Count',
          colorByPoint: true,
          animation: {
            duration: 800,
            easing: 'easeOutCubic'
          },
          data: []
        }],
        credits: {
          enabled: false
        },
        exporting: {
            enabled: false
        }
      }
    };
  }

  componentDidMount() {
    this.processData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.portfolioFaultLogData !== this.props.portfolioFaultLogData) {
      this.processData();
    }
  }

  processData = () => {
    const { portfolioFaultLogData, portfolioFaultDetails } = this.props;
    const errorCounts = {};

    portfolioFaultLogData.forEach(fault => {
      const stationId = fault.stationId;
      const stationDetail = portfolioFaultDetails.stationDetails?.find(s => s.name === stationId);
      const stationName = stationDetail ? stationDetail.name : stationId;

      fault.deviceMaps?.forEach(device => {
        // Count error codes
        device.errorCode?.forEach(code => {
          const normalizedCode = (code || '').trim().toLowerCase();
          if (code && code !== 'NaN' && normalizedCode !== 'not error') {
            if (!errorCounts[code]) {
              errorCounts[code] = { count: 0, stations: new Set() };
            }
            errorCounts[code].count += 1;
            errorCounts[code].stations.add(stationName);
          }
        });

        // Count status errors
        const statusText = device.deviceStatus;
        if (statusText && statusText.includes('Error') && !statusText.includes('Not Error')) {
          const cleanStatus = statusText.replace('Error', '').trim();
          if (cleanStatus.toLowerCase() === 'not error') return;

          if (!errorCounts[cleanStatus]) {
            errorCounts[cleanStatus] = { count: 0, stations: new Set() };
          }
          errorCounts[cleanStatus].count += 1;
          errorCounts[cleanStatus].stations.add(stationName);
        }
      });
    });

    // Filter out entries where the key is "Not Error"
    const chartData = Object.keys(errorCounts)
      .filter(key => key.trim().toLowerCase() !== 'not error')
      .map(key => {
        const maxLength = 35;
        const truncatedName = key.length > maxLength ? key.slice(0, maxLength) + '...' : key;

        return {
          name: key,
          displayName: truncatedName,
          y: errorCounts[key].count,
          affectedStations: Array.from(errorCounts[key].stations).sort((a, b) => {
            const getNumber = (name) => parseInt(name.replace(/^\D+/g, ''), 10);
            return getNumber(a) - getNumber(b);
          })
        };
      });

    this.setState({
      chartOptions: {
        ...this.state.chartOptions,
        series: [{
          name: 'Error Count',
          data: chartData
        }]
      }
    });
  };

  render() {
    const { chartOptions } = this.state;
    const { selectedPortfolioFaultStations } = this.props;

    const hasData = chartOptions.series[0].data.length > 0;
    const isStationSelected = selectedPortfolioFaultStations && selectedPortfolioFaultStations.length > 0;

    return (
      <Paper className="portfolioFaultPie">
        <Typography className="portfolioFaultTitlePie" variant="h6" color="primary">
          Error Frequency Chart
        </Typography>
        <div style={{ overflowX: 'auto' }}>
        {!isStationSelected ? (
          <Typography variant="subtitle1" style={{ margin: '20px' }}>
            Please select at least one station to view the chart.
          </Typography>
           ) : hasData ? (
          <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
          />
          ) : (
          <Typography variant="subtitle1" style={{ margin: '20px' }}>
            Data not available. Please select filters to see the chart.
          </Typography>
          )}
        </div>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => ({
  portfolioFaultLogData: state.portfolioFaultOverview?.portfolioFaultLogData || [],
  portfolioFaultDetails: state.portfolioFaultOverview?.portfolioFaultDetails || {},
  selectedPortfolioFaultStations: state.portfolioFaultOverview?.selectedPortfolioFaultStations || []
});

export default connect(mapStateToProps)(PortfolioFaultFrequencyChartByError);
